// 验证账户
export function validAccount(str) {
  const reg = /^[a-zA-Z0-9_-]{4,16}$/;
  return reg.test(str);
}

// 验证密码
export function validPwd(str) {
  const reg = /^(?=.*[1-9]{1,}).*$/;
  return reg.test(str);
}

// 验证6位数字密码
export function validPassword(str) {
  const reg = /^\d{6}$/;
  return reg.test(str);
}

// 验证手机号
export function validPhone(str) {
  //  const reg =
  //  /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])
  // |(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
  const reg = /^1\d{10}$/;
  return reg.test(str);
}

// 验证座机
export function validLandline(str) {
  const reg = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
  return reg.test(str);
}
// 验证验证码
export function validCode(str) {
  const reg = /^\d{6}$/;
  return reg.test(str);
}

// 验证金额
export function validCurrency(str) {
  const reg = /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,2})?$)|(?:^(?:0){1}$)|(?:^[0-9]\.[0-9](?:[0-9])?$)/;
  return reg.test(str);
}

// 验证银行卡
export function validBackCard(str) {
  const reg = /^[1-9]\d{9,29}$/;
  return reg.test(str);
}

// 验证邮箱
export function validEmail(str) {
  const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; // eslint-disable-line
  return reg.test(str);
}

// 验证中文
export function validateChinese(str) {
  const reg = /^[\u0391-\uFFE5]+$/;// eslint-disable-line
  return reg.test(str);
}

// 验证英文
export function validateEnglish(str) {
  const reg = /^[a-zA-Z]+$/;// eslint-disable-line
  return reg.test(str);
}

// 验证整数
export function IsInteger(str) {
  const reg = /^[-+]?\d*$/;// eslint-disable-line
  return reg.test(str);
}

// 验证数字
export function digital(str) {
  const reg = /^[0-9]*$/;// eslint-disable-line
  return reg.test(str);
}
